import { AxiosError } from "axios";
import mainApi from "../../api/mainApi";
import { UsuariosResponse } from "../../interfaces/usuarios/usuarios.interface";
import { middlewareApi } from "../../middlewares/middlewareApi";

const usersSerives = middlewareApi.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @POST
     */
    getUsers: builder.query<
      UsuariosResponse,
      {
        page: number;
        pageSize: number;
        search?: string;
      }
    >({
      queryFn: async ({ page, pageSize, search }) => {
        try {
          const { data } = await mainApi.post<UsuariosResponse>(
            "users/allUsers",
            {
              page,
              pageSize,
              search,
            }
          );
          return { data };
        } catch (error) {
          let err = error as AxiosError;
          return {
            error: err.request?.data || err.message,
          };
        }
      },
    }),
    /**
     * @GET
     */
    createUser: builder.mutation<
      any,
      {
        nombre: string;
        email: string;
        contrasenia: string;
        perfil: string;
        cedula?: string;
      }
    >({
      queryFn: async ({ nombre, contrasenia, email, perfil, cedula }) => {
        try {
          const { data } = await mainApi.post("users/new", {
            nombre,
            contrasenia,
            email,
            perfil,
            cedula,
          });
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
    /**
     * @POST
     */
    createUserClientRelation: builder.mutation<
      any,
      {
        id_usuario: number;
        id_cliente: number;
        estado: string;
        tipo: string;
      }
    >({
      queryFn: async ({ estado, id_cliente, id_usuario, tipo }) => {
        try {
          const { data } = await mainApi.post<any>(
            "usuarios-clientes/createUserClient",
            {
              estado,
              id_cliente,
              id_usuario,
              tipo,
            }
          );
          return { data };
        } catch (error: any) {
          return { error: error.response.data.message || error.message };
        }
      },
    }),
    /**
     * @PUT
     */
    disableUserClient: builder.mutation<
      any,
      {
        id_usuario: number;
        id_cliente: number;
      }
    >({
      queryFn: async ({ id_usuario, id_cliente }) => {
        try {
          const { data } = await mainApi.put<any>(
            "usuarios-clientes/disableUserClient",
            { id_usuario, id_cliente }
          );
          return { data };
        } catch (error: any) {
          return { error: error.response.data.message || error };
        }
      },
    }),
    /**
     * @POST
     */
    changePassword: builder.mutation<
      any,
      {
        contrasenia: string;
        id: number;
      }
    >({
      queryFn: async ({ contrasenia, id }) => {
        try {
          const { data } = await mainApi.post("users/changePassword", {
            contrasenia,
            id,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @POST
     */
    changeProfile: builder.mutation<
      any,
      {
        id_usuario: number;
        id_perfil: number;
      }
    >({
      queryFn: async ({ id_perfil, id_usuario }) => {
        try {
          const { data } = await mainApi.post<any>("users/cambiarPerfil", {
            id_perfil,
            id_usuario,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @POST
     */
    disableUser: builder.mutation<
      any,
      {
        id: number;
      }
    >({
      queryFn: async ({ id }) => {
        try {
          const { data } = await mainApi.post<any>("users/disableUser", {
            id,
          });
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @POST update user
     */
    updateUser: builder.mutation<
      any,
      {
        id_usuario: number;
        nombre: string;
        email: string;
        perfil: number;
        cedula: string | null;
      }
    >({
      queryFn: async ({ cedula, email, id_usuario, nombre, perfil }) => {
        try {
          const { data } = await mainApi.post("users/updateUser", {
            cedula,
            email,
            id_usuario,
            nombre,
            perfil,
          });
          return { data };
        } catch (error: any) {
          return { error: error };
        }
      },
    }),
  }),
});

export const {
  useGetUsersQuery,
  useCreateUserMutation,
  useCreateUserClientRelationMutation,
  useDisableUserClientMutation,
  useChangePasswordMutation,
  useDisableUserMutation,
  useChangeProfileMutation,
  useUpdateUserMutation,
} = usersSerives;
